import { PermissionLevel } from '@/utils/permission';
export const productionRoutes = [
  {
    component: () => import('@/pages/masterdata/productgroups/index.vue'),
    meta: {
      permissions: [{ ProductGroup: PermissionLevel.Read }],
      title: 'menu_admin_productgroups'
    },
    name: 'ProductGroups',
    path: 'productgroups'
  },
  {
    component: () => import('@/pages/masterdata/productgroups/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ ProductGroup: PermissionLevel.Write }],
      title: 'createProductGroup'
    },
    name: 'CreateProductGroup',
    path: 'productgroups/create'
  },
  {
    component: () => import('@/pages/masterdata/productgroups/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ ProductGroup: PermissionLevel.Read }],
      title: 'editProductGroup'
    },
    name: 'EditProductGroup',
    path: 'productgroups/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/producttypes/index.vue'),
    meta: {
      permissions: [{ ProductType: PermissionLevel.Read }],
      title: 'menu_admin_producttypes'
    },
    name: 'ProductTypes',
    path: 'producttypes'
  },
  {
    component: () => import('@/pages/masterdata/producttypes/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ ProductType: PermissionLevel.Write }],
      title: 'createProductType'
    },
    name: 'CreateProductType',
    path: 'producttypes/create'
  },
  {
    component: () => import('@/pages/masterdata/producttypes/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ ProductType: PermissionLevel.Read }],
      title: 'editProductType'
    },
    name: 'EditProductType',
    path: 'producttypes/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/collections/index.vue'),
    meta: {
      permissions: [{ Collection: PermissionLevel.Read }],
      title: 'menu_admin_collections',
      refreshOnDomainChange: true
    },
    name: 'Collections',
    path: 'collections'
  },
  {
    component: () => import('@/pages/masterdata/collections/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Collection: PermissionLevel.Write }],
      title: 'createCollection',
      disableDomainChange: true
    },
    name: 'CreateCollection',
    path: 'collections/create'
  },
  {
    component: () => import('@/pages/masterdata/collections/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Collection: PermissionLevel.Read }],
      title: 'editCollection',
      disableDomainChange: true
    },
    name: 'EditCollection',
    path: 'collections/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/finishtypes/index.vue'),
    meta: {
      permissions: [{ FinishType: PermissionLevel.Read }],
      title: 'menu_admin_finishtypes'
    },
    name: 'FinishTypes',
    path: 'finishtypes'
  },
  {
    component: () => import('@/pages/masterdata/finishtypes/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ FinishType: PermissionLevel.Write }],
      title: 'createFinishType'
    },
    name: 'CreateFinishType',
    path: 'finishtypes/create'
  },
  {
    component: () => import('@/pages/masterdata/finishtypes/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ FinishType: PermissionLevel.Read }],
      title: 'editFinishType'
    },
    name: 'EditFinishType',
    path: 'finishtypes/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/domains/productgroups/createProductGroup.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Domain: PermissionLevel.Write }],
      title: 'createLinkDomainProductGroup',
      disableDomainChange: true
    },
    name: 'CreateLinkDomainProductGroup',
    path: 'domains/edit/:domainID/productgroups/create/:productGroupID'
  },
  {
    component: () => import('@/pages/masterdata/domains/productgroups/editProductGroup.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Domain: PermissionLevel.Write }],
      title: 'editLinkDomainProductGroup',
      disableDomainChange: true
    },
    name: 'EditLinkDomainProductGroup',
    path: 'domains/edit/:domainID/productgroups/edit/:productGroupID'
  },
  {
    component: () => import('@/pages/masterdata/reasonstockcorrection/index.vue'),
    meta: {
      permissions: [{ ReasonStockCorrection: PermissionLevel.Read }],
      title: 'menu_admin_reasonstockcorrections'
    },
    name: 'ReasonStockCorrections',
    path: 'reasonstockcorrections'
  },
  {
    component: () => import('@/pages/masterdata/reasonstockcorrection/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ ReasonStockCorrection: PermissionLevel.Write }],
      title: 'createReasonStockCorrection'
    },
    name: 'CreateReasonStockCorrection',
    path: 'reasonstockcorrections/create'
  },
  {
    component: () => import('@/pages/masterdata/reasonstockcorrection/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ ReasonStockCorrection: PermissionLevel.Read }],
      title: 'editReasonStockCorrection'
    },
    name: 'EditReasonStockCorrection',
    path: 'reasonstockcorrections/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/yarns/index.vue'),
    meta: {
      permissions: [{ Yarn: PermissionLevel.Read }],
      title: 'menu_admin_yarns'
    },
    name: 'Yarns',
    path: 'yarns'
  },
  {
    component: () => import('@/pages/masterdata/yarns/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ Yarn: PermissionLevel.Write }],
      title: 'createYarn'
    },
    name: 'CreateYarn',
    path: 'yarns/create'
  },
  {
    component: () => import('@/pages/masterdata/yarns/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ Yarn: PermissionLevel.Read }],
      title: 'editYarn'
    },
    name: 'EditYarn',
    path: 'yarns/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/printtemplates/index.vue'),
    meta: {
      permissions: [{ PrintTemplate: PermissionLevel.Read }],
      title: 'menu_admin_printtemplates'
    },
    name: 'PrintTemplates',
    path: 'printtemplates'
  },
  {
    component: () => import('@/pages/masterdata/printtemplates/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ PrintTemplate: PermissionLevel.Write }],
      title: 'createPrintTemplate'
    },
    name: 'CreatePrintTemplate',
    path: 'printtemplates/create'
  },
  {
    component: () => import('@/pages/masterdata/printtemplates/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ PrintTemplate: PermissionLevel.Read }],
      title: 'editPrintTemplate'
    },
    name: 'EditPrintTemplate',
    path: 'printtemplates/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/templateimages/index.vue'),
    meta: {
      permissions: [{ TemplateImage: PermissionLevel.Read }],
      title: 'menu_admin_templateimages'
    },
    name: 'TemplateImages',
    path: 'templateimages'
  },
  {
    component: () => import('@/pages/masterdata/templateimages/create.vue'),
    hidden: true,
    meta: {
      icon: 'edit',
      permissions: [{ TemplateImage: PermissionLevel.Write }],
      title: 'createTemplateImage'
    },
    name: 'CreateTemplateImage',
    path: 'templateimages/create'
  },
  {
    component: () => import('@/pages/masterdata/templateimages/edit.vue'),
    hidden: true,
    meta: {
      noCache: true,
      permissions: [{ TemplateImage: PermissionLevel.Read }],
      title: 'editTemplateImage'
    },
    name: 'EditTemplateImage',
    path: 'templateimages/edit/:id'
  },
  {
    component: () => import('@/pages/masterdata/returncauses/index.vue'),
    meta: {
      permissions: [{ ReturnCause: PermissionLevel.Read }],
      title: 'menu_return_causes'
    },
    name: 'ReturnCauses',
    path: 'return-causes'
  },
  {
    component: () => import('@/pages/masterdata/returncauses/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ ReturnCause: PermissionLevel.Write }],
      title: 'createReturnCause'
    },
    name: 'CreateReturnCause',
    path: 'return-causes/create'
  },
  {
    component: () => import('@/pages/masterdata/returncauses/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ ReturnCause: PermissionLevel.Read }],
      title: 'editReturnCause'
    },
    name: 'EditReturnCause',
    path: 'return-causes/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/returnreasoncategories/index.vue'),
    meta: {
      permissions: [{ ReturnReasonCategory: PermissionLevel.Read }],
      title: 'menu_return_type_categories'
    },
    name: 'ReturnReasonCategories',
    path: 'return-reason-categories'
  },
  {
    component: () => import('@/pages/masterdata/returnreasoncategories/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ ReturnReasonCategory: PermissionLevel.Write }],
      title: 'createReturnReasonCategory'
    },
    name: 'CreateReturnReasonCategory',
    path: 'return-reason-categories/create'
  },
  {
    component: () => import('@/pages/masterdata/returnreasoncategories/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ ReturnReasonCategory: PermissionLevel.Read }],
      title: 'editReturnReasonCategory'
    },
    name: 'EditReturnReasonCategory',
    path: 'return-reason-categories/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/orderlinestatuses/index.vue'),
    meta: {
      permissions: [{ OrderLineStatus: PermissionLevel.Read }],
      title: 'menu_order_line_statuses'
    },
    name: 'OrderLineStatuses',
    path: 'orderlinestatuses'
  },
  {
    component: () => import('@/pages/masterdata/orderlinestatuses/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ OrderLineStatus: PermissionLevel.Write }],
      title: 'createOrderLineStatus'
    },
    name: 'CreateOrderLineStatus',
    path: 'orderlinestatuses/create'
  },
  {
    component: () => import('@/pages/masterdata/orderlinestatuses/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ OrderLineStatus: PermissionLevel.Read }],
      title: 'editOrderLineStatus'
    },
    name: 'EditOrderLineStatus',
    path: 'orderlinestatuses/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/printerclients/index.vue'),
    meta: {
      permissions: [{ PrinterClient: PermissionLevel.Read }],
      title: 'menu_printer_clients'
    },
    name: 'PrinterClients',
    path: 'printer-clients'
  },
  {
    component: () => import('@/pages/masterdata/printerclients/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ PrinterClient: PermissionLevel.Write }],
      title: 'createPrinterClient'
    },
    name: 'CreatePrinterClient',
    path: 'printer-clients/create'
  },
  {
    component: () => import('@/pages/masterdata/printerclients/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ PrinterClient: PermissionLevel.Read }],
      title: 'editPrinterClient'
    },
    name: 'EditPrinterClient',
    path: 'printer-clients/edit/:id(\\d+)'
  },
  {
    component: () => import('@/pages/masterdata/specials/index.vue'),
    meta: {
      permissions: [{ Special: PermissionLevel.Read }],
      title: 'menu_specials'
    },
    name: 'Specials',
    path: 'specials'
  },
  {
    component: () => import('@/pages/masterdata/specials/create.vue'),
    hidden: true,
    meta: {
      permissions: [{ Special: PermissionLevel.Write }],
      title: 'createSpecial'
    },
    name: 'CreateSpecial',
    path: 'specials/create'
  },
  {
    component: () => import('@/pages/masterdata/specials/edit.vue'),
    hidden: true,
    meta: {
      permissions: [{ Special: PermissionLevel.Read }],
      title: 'editSpecial'
    },
    name: 'EditSpecial',
    path: 'specials/edit/:id(\\d+)'
  }
];
